module.exports = __webpack_public_path__ + "img/4.7edb2462.png";